$(function ($) {
  /*---------------- Side barr slider ------------------*/

  $('.sidebar-content > .title').on("click", function (e) {
    $(this).next('.inner-content').slideToggle(600);
    $(this).toggleClass('open');
    e.stopPropagation();
    e.preventDefault();
  });
  /*---------------- Side barr slider End------------------*/

  $(".side-menu-icon").click(function () {
    $(".side-menu-toggle").addClass("filter-open");
  });
  $(".icon-close-5").click(function () {
    $(".side-menu-toggle").removeClass("filter-open");
  });

  $(".filter-btn").click(function () {
    $(".sidebar-col").addClass("sidebar-open");
  });
  $(".close-btn").click(function () {
    $(".sidebar-col").removeClass("sidebar-open");
  });

  $('.coll-slider').slick({
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    centerMode: true,
    responsive: [
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1366,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.popup-youtube').magnificPopup({
    disableOn: 700,
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false
  });


  /*----- qty Start --------*/ 

  jQuery(document).ready(function () { 

    $('.qty-btn.plus').click(function (e) {

      // Stop acting like a button
      e.preventDefault();
      // Get the field name
      fieldName = $(this).attr('field');
      // Get its current value
      var currentVal = parseInt($('input[name=' + fieldName + ']').val());
      // If is not undefined
      if (!isNaN(currentVal)) {
        // Increment
        $('input[name=' + fieldName + ']').val(currentVal + 1);
      } else {
        // Otherwise put a 0 there
        $('input[name=' + fieldName + ']').val(1);
      }
    });
    // This button will decrement the value till 0
    $(".qty-btn.minus").click(function (e) {

      // Stop acting like a button
      e.preventDefault();
      // Get the field name
      fieldName = $(this).attr('field');
      // Get its current value
      var currentVal = parseInt($('input[name=' + fieldName + ']').val());
      // If it isn't undefined or its greater than 0
      if (!isNaN(currentVal) && currentVal > 1) {
        // Decrement one
        $('input[name=' + fieldName + ']').val(currentVal - 1);
      } else {
        // Otherwise put a 0 there
        $('input[name=' + fieldName + ']').val(1);
      }
    });
    function openTab(event, cityName) {
      var i, tabcontent, tablinks;
      tabcontent = document.getElementsByClassName("tabcontent");
      for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
      }
      tablinks = document.getElementsByClassName("tablinks");
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
      }
      document.getElementById(cityName).style.display = "block";
      event.currentTarget.className += " active";
    }

    //Back to Top Jq start//
    $('.back-to-top').click(function() {
      $('body,html').animate({
        scrollTop: 0
      }, 1000);
      return false;
    });
    $(window).scroll(function() {
      if ($(this).scrollTop() > 1000) {
        $('.back-to-top').slideDown();
      } else {

        $('.back-to-top').slideUp();
      }
    });
    //Back to Top Jq End//

    $(".item-swatch li label, .showoption ul li a").click(function() {
      $(this).parent().addClass('active').siblings().removeClass('active');

    });

  });

  /*----- qty End --------*/ 


  /*---------------- Easy Responsive Tab ------------------*/
  if ($('#parentHorizontalTab').length) {
    $('#parentHorizontalTab').easyResponsiveTabs({
      type: 'default', //Types: default, vertical, accordion
      width: 'auto', //auto or any width like 600px
      fit: true, // 100% fit in a container
      tabidentify: 'hor_1', // The tab groups identifier
      activate: function(event) { // Callback function if tab is switched
        var $tab = $(this);
        var $info = $('#nested-tabInfo');
        var $name = $('span', $info);
        $name.text($tab.text());
        $info.show();
      }
    });
  }
  /*---------------- Easy Responsive Tab ------------------*/

  
  
      
/* Shop slider */ 

  $('.slider-wrp').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    adaptiveHeight: true,
    asNavFor: '.shop-slider-nav'
  });
  $('.shop-slider-nav').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.slider-wrp',
    dots: false,
    arrows: true,
    infinite: false,
    focusOnSelect: true,
    vertical:true,
    adaptiveHeight: true,
    verticalSwiping:true,
    responsive: [

      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
          vertical:true,
          slidesToScroll: 1
        } 
      },     
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          vertical:false,
          verticalSwiping:false
          // horizontal:true,

        }
      },
      { 
        breakpoint:768,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          vertical:false,
          verticalSwiping:false
        } 
      }, 
      { 
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          vertical:false,
          verticalSwiping:false
        }
      },
      {
        breakpoint: 360,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          vertical:false,
          verticalSwiping:false
        }
      }

    ]
  });

  /* Shop slider end*/  
  
  $('.img_slider').slick({
    infinite: true,
    arrows:false,
    dots:true,
    slidesToShow: 1,
    slidesToScroll: 1
  });
  
  if($(window).width() <= '1199'){
  		$('.announce_info ul').slick({
          infinite: true,
          arrows:false,
          dots:false,
          autoplay: true,
          adaptiveHeight: true,
		  autoplaySpeed: 2000,
          slidesToShow: 1,
          slidesToScroll: 1
        });
  }
  if($(window).width() <= '991'){
  	$('.logo-bar').slick({
          infinite: true,
          arrows:false,
          dots:false,
          slidesToShow: 2,
          slidesToScroll: 1,
      	  responsive: [
            {
              breakpoint: 480,
              settings: {
                autoplay: true,
                autoplaySpeed: 2000,
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }

          ]
    });
  }
  
});

